
    import { mapState, mapGetters } from 'vuex';

    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
    import {
        faChartPieAlt as farChartPieAlt,
    } from '@fortawesome/pro-regular-svg-icons/faChartPieAlt';
    import {
        faExternalLink as farExternalLink,
    } from '@fortawesome/pro-regular-svg-icons/faExternalLink';
    import {
        faGlobeAmericas as farGlobeAmericas,
    } from '@fortawesome/pro-regular-svg-icons/faGlobeAmericas';

    import {
        faUsers as farUsers,
    } from '@fortawesome/pro-regular-svg-icons/faUsers';

    import {
        faFacebookF as fabFacebookF,
    } from '@fortawesome/free-brands-svg-icons/faFacebookF';
    import {
        faTwitter as fabTwitter,
    } from '@fortawesome/free-brands-svg-icons/faTwitter';
    import {
        faLinkedinIn as fabLinkedinIn,
    } from '@fortawesome/free-brands-svg-icons/faLinkedinIn';
    import {
        faInstagram as fabInstagram,
    } from '@fortawesome/free-brands-svg-icons/faInstagram';
    import {
        faYoutube as fabYoutube,
    } from '@fortawesome/free-brands-svg-icons/faYoutube';

    import CompanyEEO from '@/components/Company/CompanyEEO';

    export default {
        name: 'CompanyDetailsDesktop',

        components: {
            FontAwesomeIcon,
            CompanyEEO,
        },

        data() {
            return {
                isCompanyTextActive: false,
                icons: {
                    farChartPieAlt,
                    farGlobeAmericas,
                    farUsers,
                    farExternalLink,
                },
            };
        },

        computed: {
            ...mapState({
                $_brand: state => state.search.brand,
            }),

            ...mapGetters('search', {
                $_companyEEO: 'companyEEO',
                $_companyName: 'companyName',
                $_companySlug: 'companySlug',
                $_companyAbout: 'companyAbout',
                $_companySize: 'companySize',
                $_companyMedias: 'companyMedias',
                $_companyWebsite: 'companyWebsite',
                $_companySector: 'companySector',
                $_companyIndustry: 'companyIndustry',
            }),

            companyFeatures() {
                const features = [
                    { label: 'Sector', value: this.$_companySector },
                    { label: 'Industry', value: this.$_companyIndustry },
                    { label: 'Company Size', value: this.$_companySize },
                ];

                return features.filter(o => o.value);
            },

            companyLink() {
                return this.$_companyWebsite ? `${this.$_companyWebsite}?utm_source=careerone&utm_medium=careerone_brand_page&utm_campaign=${this.$_companySlug}` : '';
            },

            companySocialMedia() {
                const socialMedias = [
                    { name: 'facebook', url: this.$_brand.facebook, icon: fabFacebookF },
                    { name: 'linkedin', url: this.$_brand.linkedin, icon: fabLinkedinIn },
                    { name: 'twitter', url: this.$_brand.twitter, icon: fabTwitter },
                    { name: 'instagram', url: this.$_brand.instagram, icon: fabInstagram },
                    { name: 'youtube', url: this.$_brand.youtube, icon: fabYoutube },
                ];

                return socialMedias.filter(o => o.url);
            },
        },
    };
